import { useIntl } from '@weenat/wintl'
import Text from 'app/src/kit/Text'
import { memo } from 'react'
import { styled } from 'styled-components'
import FullScreenSurface from './fullscreens/FullScreenSurface'
import { LogoFullLight } from './icons/logos'
import Link from './LinkComponent'
import StoreBadge from './StoreBadge'

const StyledText = styled(Text)`
  text-align: center;
  max-width: 640px;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`

const MdStyledText = styled(StyledText)`
  @media (max-width: 480px) {
    font-size: 14px;
  }
`

const ContentContainer = styled(Flex)`
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;

  padding: 64px;

  overflow-y: scroll;
`

const GradientSurface = styled(FullScreenSurface)`
  background: linear-gradient(223deg, #002635 5%, #015579 50%, #0172a4 100%);
`

const DownloadMobileScreen = () => {
  const { t } = useIntl()

  return (
    <GradientSurface>
      <ContentContainer>
        <Flex $flexDirection='column' $alignItems='center' $justifyContent='center' $gap='xl'>
          <Link href={t('weenat.links.website')} target='_blank'>
            <LogoFullLight width={'100%'} height={64} />
          </Link>
          <Flex $flexDirection='column' $alignItems='center' $justifyContent='center' $gap='lg'>
            <StyledText $color={'grayscale.white'} $fontSize='2xl' $fontWeight='medium'>
              {t('titles.install_app_title', {
                live: t('titles.install_app_title_live')
              })}
            </StyledText>
            <MdStyledText $color={'grayscale.white'} $fontSize='lg' $textAlign='center'>
              {t('titles.install_app_subtitle')}
            </MdStyledText>
          </Flex>
          <Flex $alignItems='center' $flexWrap='wrap' $justifyContent='center'>
            <StoreBadge />
          </Flex>
        </Flex>
      </ContentContainer>
    </GradientSurface>
  )
}

export default memo(DownloadMobileScreen)
